module.exports = __webpack_public_path__ + "static/media/fogg-message-sent.5a31f284.svg";